import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { navRouteTypes } from '../../../types/nav';
import { userTypes } from '../../../types/user';

import { getCurrentAllotments, getFutureAllotments, getCanShowInvoicesLink } from '../../../gamedayAccount/selectors';
import { getUserData } from '../../../user/selectors';

import SmallScreenLink from './SmallScreenLink';
import { Date } from '../../../components';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { Invoices, TransactionReports } from '../../../orders';

import { isViewOnly } from '../../../util/rolePermissions';

const subHeaderStyle = 'body-4';

export const SmallScreenList = ({ isOrders, routes, toggleNavMenu, user, canShowInvoicesLink, ...props }) => (
  <ul className='navigation__list'>
    {routes.map(route => (
      <Fragment key={`smallScreenLink-${route.path}`}>
        {route.nav && (!route.limitToRoles || route.limitToRoles.indexOf(user.role) > -1) && (
          <SmallScreenLink
            to={route.path}
            className={classnames(subHeaderStyle)}
            label={<TranslatedCopy id={route.title} />}
            onClick={toggleNavMenu}
            disabled={route.disableLink ?? false}
          />
        )}
        {route.routes &&
          route.routes
            .filter(subSubRoute => subSubRoute.nav !== false)
            .map(section => {
              const disableValue = props[section.disableWhenEmpty];
              const titleSubCopy = props[section.titleSubCopy];

              return (
                (!section.limitToRoles || section.limitToRoles.indexOf(user.role) > -1) && (
                  <SmallScreenLink
                    key={`smallScreenLink__subRoute-${section.path}`}
                    to={section.path}
                    className={classnames(subHeaderStyle, {
                      isDisabled: disableValue && Object.keys(disableValue).length === 0
                    })}
                    label={
                      <span>
                        <TranslatedCopy id={section.title} />
                        {titleSubCopy && titleSubCopy.contractEndDate && titleSubCopy.contractEndDate && (
                          <span className='nav__title-subCopy body-4 pl2-sm'>
                            (
                            <Date value={titleSubCopy.contractStartDate} />
                            {' - '}
                            <Date value={titleSubCopy.contractEndDate} />)
                          </span>
                        )}
                      </span>
                    }
                    onClick={toggleNavMenu}
                  />
                )
              );
            })}
      </Fragment>
    ))}
    {isOrders && canShowInvoicesLink && <Invoices isMobile />}
    {isOrders && !isViewOnly(user.role) && <TransactionReports isMobile />}
  </ul>
);

SmallScreenList.defaultProps = {
  isOrders: false,
  user: null
};

SmallScreenList.propTypes = {
  isOrders: PropTypes.bool,
  routes: navRouteTypes.isRequired,
  user: userTypes,
  toggleNavMenu: PropTypes.func.isRequired,
  canShowInvoicesLink: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state, true),
  canShowInvoicesLink: getCanShowInvoicesLink(state),
  user: getUserData(state)
});

const connector = connect(mapStateToProps, {});

export default connector(SmallScreenList);
